export default __webpack_public_path__ + "static/media/flagUSA.5eb1f78d.svg";